import { useState } from "react";
import { LocateFixed, Navigation, X, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { mapsUrl } from "@/lib/api";

export function LocationPicker({ form, update, locked }) {
  const [locating, setLocating] = useState(false);
  const has = form.lat != null && form.lng != null;
  const nav = mapsUrl(form);

  const locate = () => {
    if (!navigator.geolocation) {
      toast.error("Geolocalizzazione non supportata da questo dispositivo");
      return;
    }
    setLocating(true);
    navigator.geolocation.getCurrentPosition(
      (p) => {
        update({ lat: Number(p.coords.latitude.toFixed(6)), lng: Number(p.coords.longitude.toFixed(6)) });
        toast.success(`Posizione rilevata (precisione ~${Math.round(p.coords.accuracy)} m). Ricorda di salvare.`);
        setLocating(false);
      },
      () => {
        toast.error("Impossibile rilevare la posizione: consenti l'accesso alla posizione");
        setLocating(false);
      },
      { enableHighAccuracy: true, timeout: 20000, maximumAge: 0 }
    );
  };

  const d = 0.004;
  const embed = has && `https://www.openstreetmap.org/export/embed.html?bbox=${form.lng - d},${form.lat - d},${form.lng + d},${form.lat + d}&layer=mapnik&marker=${form.lat},${form.lng}`;

  return (
    <div className="sm:col-span-2 space-y-3" data-testid="location-picker">
      <p className="text-sm font-medium">Posizione sulla mappa</p>
      {has ? (
        <iframe title="Mappa" src={embed} className="w-full h-56 rounded-xl border border-[var(--border)]" data-testid="location-map" />
      ) : (
        <p className="text-sm text-[var(--muted)]" data-testid="location-empty">Nessun punto salvato. Quando sei sul posto tocca “Usa la mia posizione”.</p>
      )}
      {has && <p className="font-mono text-xs text-[var(--muted)]" data-testid="location-coords">{form.lat}, {form.lng}</p>}
      <div className="flex flex-wrap gap-2">
        {!locked && (
          <button type="button" onClick={locate} disabled={locating} className="btn-secondary h-11 px-4" data-testid="use-my-location-button">
            {locating ? <Loader2 className="h-5 w-5 animate-spin" /> : <LocateFixed className="h-5 w-5" />} Usa la mia posizione
          </button>
        )}
        {nav && (
          <a href={nav} target="_blank" rel="noreferrer" className="btn-primary h-11 px-4" data-testid="open-google-maps-button">
            <Navigation className="h-5 w-5" /> Apri in Google Maps
          </a>
        )}
        {has && !locked && (
          <button type="button" onClick={() => update({ lat: null, lng: null })} className="btn-ghost h-11 px-3" data-testid="remove-location-button"><X className="h-4 w-4" /> Rimuovi punto</button>
        )}
      </div>
    </div>
  );
}
